import React from 'react';
import { Company } from '../../../../../types/company';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import { Collapsable } from '../../../Collapsable';
import { FeatureToggleItem, FeatureToggleTitle, FeatureToggleExplanation } from '../common';

interface KitFeatureTogglesViewProps {
  company: Company;
  update: (company: Company) => Promise<void>;
}

export default function KitFeatureTogglesView({ company, update }: KitFeatureTogglesViewProps) {
  const copy = new Company(company);
  const toggles = copy.settings.featureToggles.kits;

  return (
    <Collapsable
      open={toggles.kits}
      header={
        <FeatureToggleItem
          value={toggles.kits}
          onChange={async value => await update(copy.withKitsFeatureToggle(value))}
        >
          <FeatureToggleTitle text={translate({ key: TranslationKey.kitKitFeatureToggleTitle })} />
          <FeatureToggleExplanation text={translate({ key: TranslationKey.kitKitFeatureToggleExplanation })} />
        </FeatureToggleItem>
      }
    >
      <FeatureToggleItem
        indent={1}
        value={toggles.refillKits}
        onChange={async value => await update(copy.withRefillKitsFeatureToggle(value))}
      >
        <FeatureToggleTitle text={translate({ key: TranslationKey.kitRefillKitsFeatureToggleTitle })} />
        <FeatureToggleExplanation text={translate({ key: TranslationKey.kitRefillKitsFeatureToggleExplanation })} />
      </FeatureToggleItem>
    </Collapsable>
  );
}
